import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get, post } from "common/helpers/HTTP";
import type { LinkedInProfile } from "common/types";

import type { BlacklistType, Company } from "../types";

async function getBlacklistRequest(workspaceId: string, type: BlacklistType) {
  const pagingQueryParams = "?page=0&size=100";

  //the companies are listed through a plain get, the accounts through the
  //search - its array filters don't round-trip through a query string
  if (type === "companies") {
    const { companies } = await get(
      `workspaces/${workspaceId}/blacklist-companies${pagingQueryParams}`,
    );
    return companies;
  }

  const { profiles } = await post(
    `workspaces/${workspaceId}/blacklist-search${pagingQueryParams}`,
  );
  return profiles;
}
export default function useBlackList<T extends BlacklistType>(type: T) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { blacklistKeys } = getQueryKeys(workspaceId);

  const {
    isLoading: isLoadingBlacklist,
    data: blacklist,
    isError: isBlacklistError,
    refetch: refetchBlacklist,
  } = useQuery<(T extends "companies" ? Company : LinkedInProfile)[]>({
    queryKey: blacklistKeys.list(type),
    queryFn: () => getBlacklistRequest(workspaceId, type),
  });

  return {
    blacklist,
    refetchBlacklist,
    isLoadingBlacklist,
    isBlacklistError,
  };
}
